import dayjs from 'dayjs';

// Single source of truth for how dates are DISPLAYED to users across the portal.
// Storage / API / form inputs stay ISO (YYYY-MM-DD); only on-screen display uses
// this, so dates look the same everywhere and don't drift with browser locale.
export const DATE_DISPLAY_FORMAT = 'DD/MM/YYYY';
export const DATETIME_DISPLAY_FORMAT = 'DD/MM/YYYY hh:mm A';

// Format any date-ish value (ISO string, Date, dayjs, epoch ms) as DD/MM/YYYY.
// Returns `fallback` ('-') for null / empty / invalid so the UI never renders
// "Invalid Date".
export const formatDate = (value, fallback = '-') => {
  if (value === null || value === undefined || value === '') return fallback;
  const d = dayjs(value);
  return d.isValid() ? d.format(DATE_DISPLAY_FORMAT) : fallback;
};

// Date + time display: DD/MM/YYYY hh:mm AM/PM.
export const formatDateTime = (value, fallback = '-') => {
  if (value === null || value === undefined || value === '') return fallback;
  const d = dayjs(value);
  return d.isValid() ? d.format(DATETIME_DISPLAY_FORMAT) : fallback;
};
